import React, {useState} from 'react';
import colors from '../../../../../../util/colors';
import {strings} from '../../../../../../util/strings';
import {deepStringObjectMerger} from '../../../../../../util/utility';
import AppButton from '../../../../../app-button';
import './styles.scss';

import {Column, Row} from '../../../../../layout';
import ModalTemplate from '../../../../../modal';
import * as fonts from '../../../../../../util/fonts';
import {compose} from 'redux';
import {connect} from 'react-redux';
import alertQuestion from '../../../../../../assets/alert-question.svg';
import {remove} from '../../../../../../api/api';
import {uriCleanUser} from '../../../../../../api/endpoints';
import {AuthConsumer} from '../../../../../../providers/AuthProvider';

interface ConfirmPasswordModalProps {
  show: any;
  labels: typeof strings.pt.virtualCard;
  setShow(value: any): void;
}

function ConfirmPasswordModal({
  show,
  labels: labelsFromRedux,
  setShow,
}: ConfirmPasswordModalProps) {
  const labels = deepStringObjectMerger(
    strings.pt.virtualCard,
    labelsFromRedux,
  );
  const [submitting, setSubmitting] = useState(false);
  const [generalError, setGeneralError] = useState(false);

  const featureName = 'VirtualCard-ConfirmPassword';

  const onSubmit = async (logout: any) => {
    localStorage.setItem('redirectToRegister', 'true');
    setSubmitting(true);

    try {
      await remove(uriCleanUser(), featureName).then(() => {
        logout();
      });
    } catch {
      setGeneralError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalTemplate
      hideFooter={true}
      cross={true}
      centered={false}
      show={show}
      className="confirm-password-modal"
      title={labels?.changeInsurance_wishToContinue_title}
      titleStyle={{...fonts.L, ...fonts.SemiBold}}
      onHide={() => {
        setShow(false);
        setGeneralError(false);
      }}
      size="lg">
      <AuthConsumer>
        {({logout}) => (
          <>
            <Row>
              <img className="alert-question" src={alertQuestion} alt="alert" />
            </Row>
            <Column
              className="data-not-found-description"
              style={{
                ...fonts.MM,
                ...fonts.Medium,
                color: colors.alertRed,
              }}>
              {labels?.changeInsurance_wishToContinue_question}
            </Column>
            <Row>
              <span
                className="insert-password-modal-description"
                style={{...fonts.MM, ...fonts.Light}}>
                {labels?.changeInsurance_wishToContinue_text}
              </span>
            </Row>
            {generalError && (
              <Row
                className="wrong-password-error-text"
                style={{
                  ...fonts.M,
                  ...fonts.SemiBold,
                  color: colors.alertRed,
                }}>
                {`${labels?.changeInsuranceData_generalErrorOcurred} ${labels?.changeInsuranceData_generalErrorTryAgain}`}
              </Row>
            )}
            <Row className="app-form-confirm-password-container-row">
              <Row className="confirm-buttons-row">
                <Column className="cancel-column">
                  <AppButton
                    className="confirm-password-cancel-button"
                    variant="secondary"
                    onClick={() => {
                      setShow(false);
                      setGeneralError(false);
                    }}>
                    {labels?.changeInsurance_wishToContinue_cancelButton}
                  </AppButton>
                </Column>
                <Column className="submit-column">
                  <AppButton
                    variant="secondary"
                    onClick={async () => {
                      onSubmit(logout);
                    }}
                    disabled={submitting}
                    className="confirm-password-submit-button">
                    {labels?.changeInsurance_wishToContinue_okButton}
                  </AppButton>
                </Column>
              </Row>
            </Row>
          </>
        )}
      </AuthConsumer>
    </ModalTemplate>
  );
}

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.virtualCard ?? {},
});

export default compose(connect(mapStateToProps)(ConfirmPasswordModal));
